export enum LogTypes {
    info = 'info',
    debug = 'debug',
    error = 'error',
    warn = 'warn',
}

export interface Logger {
    log: (type: LogTypes, entry: string, customData?: Object) => void;
    debug: (message: string, customData?: Object) => void;
    info: (message: string, customData?: Object) => void;
    warn: (message: string, customData?: Object) => void;
    error: (error: string, customData?: Object) => void;
}
